import { create } from 'zustand'
import { ChatState, ChatMessage, WheelOption } from '../types'
import { streamChat } from '../services/api'

export const useChatStore = create<ChatState>((set, get) => ({
  messages: [],
  isLoading: false,
  decision: null,

  setDecision: (decision: WheelOption) => {
    set({ decision })
  },

  addMessage: (message: ChatMessage) => {
    set((state) => ({
      messages: [...state.messages, message],
    }))
  },

  sendMessage: async (content: string) => {
    const { decision } = get()
    
    // Prevent sending empty messages
    if (!content.trim()) {
      return
    }
    
    const userMessage: ChatMessage = {
      id: Date.now().toString(),
      role: 'user',
      content,
      timestamp: new Date(),
    }

    set((state) => ({
      messages: [...state.messages, userMessage],
      isLoading: true,
    }))

    // Create assistant message placeholder
    const assistantMessageId = (Date.now() + 1).toString()
    const assistantMessage: ChatMessage = {
      id: assistantMessageId,
      role: 'assistant',
      content: '',
      timestamp: new Date(),
    }

    // Add empty assistant message
    set((state) => ({
      messages: [...state.messages, assistantMessage],
    }))

    try {
      await streamChat(
        content,
        {
          decision: decision?.text,
          history: get().messages.map(m => ({ role: m.role, content: m.content }))
        },
        // onChunk callback
        (chunk: string) => {
          set((state) => ({
            messages: state.messages.map(msg => 
              msg.id === assistantMessageId 
                ? { ...msg, content: msg.content + chunk }
                : msg
            )
          }))
        },
        // onComplete callback
        () => {
          set({ isLoading: false })
        },
        // onError callback
        (error: string) => {
          console.error('Stream chat error:', error)
          set((state) => ({
            messages: state.messages.map(msg => 
              msg.id === assistantMessageId 
                ? { ...msg, content: msg.content + '\n\n[Error: ' + error + ']' }
                : msg
            ),
            isLoading: false
          }))
        }
      )
    } catch (error) {
      console.error('Failed to send message:', error)
      set((state) => ({
        messages: state.messages.map(msg => 
          msg.id === assistantMessageId 
            ? { ...msg, content: msg.content + '\n\n[Error: Failed to send message]' }
            : msg
        ),
        isLoading: false
      }))
    }
  },

  clearMessages: () => {
    set({ messages: [] })
  },
})) 